import EditableTable from "./editable-table";

export default EditableTable;
